module.exports = __webpack_public_path__ + "img/logo_login_banner.9c6b2cfb.png";